import { RightOutlined } from "@ant-design/icons";

function ProductList(props) {
  let { products, isTabletOrMobile } = props;

  const productClicked = (product, event) => {
    window.open(`/${product.product_url}`, "_blank");
  };

  return (
    <div className="featured-products-list">
      {products?.map((product, index) => (
        <div
          key={index}
          className="product-tile"
          onClick={(event) => productClicked(product, event)}
        >
          <img
            src={product.image_path}
            alt={product.product_name}
            className="product-image"
          />

          <div className="product-content">
            <h3 className="product-header">{product.product_name}</h3>

            <div className="product-subtext">
              {product.products_spec?.slice(0, 2).map((spec, specIndex) => (
                <span key={spec.specification_order}>
                  {spec.parameter}: {spec.specifications}
                  {specIndex < 1 && product.products_spec.length > 1 && <br />}
                </span>
              ))}
            </div>

            <div className="view-details-container">
              <button
                className="view-details-button"
                onClick={(event) => {
                  event.stopPropagation();
                  productClicked(product, event);
                }}
              >
                <span className="view-details-text">View Details</span>
                <RightOutlined style={{ color: "#009EFF", fontSize: "12px" }} />
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProductList;
